// src/stone/illustrations/TabletIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var TabletIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m50.048 22.565-1.772 5.401-.362 1.104-.194.588-6.817 20.76a3.75 3.75 0 0 1-4.737 2.392l-14.445-4.742a3.746 3.746 0 0 1-2.392-4.733l9.145-27.847a3.75 3.75 0 0 1 4.734-2.395l7.558 2.481 6.887 2.262a3.744 3.744 0 0 1 2.395 4.73"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m50.048 22.566-1.772 5.4-6.785-7.178-2.955-3.13c.4-.232 1.24-1.046 2.23-2.083l6.887 2.261a3.744 3.744 0 0 1 2.395 4.73M47.914 29.067l-.194.588-5.876-6.151c-.101-.109-.047-.306.058-.385.13-.092.283-.051.385.057.649.684 1.304 1.365 1.953 2.048q1.84 1.92 3.674 3.843"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m31.656 51.325-14.62-4.8a3.747 3.747 0 0 1-2.393-4.732l9.146-27.847a3.747 3.747 0 0 1 4.733-2.392l14.62 4.8a3.747 3.747 0 0 1 2.392 4.733L36.39 48.934a3.75 3.75 0 0 1-4.733 2.391"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m42.564 21.775-16.783-5.51-8.149 24.813 16.783 5.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m18.265 40.758 7.837-23.864 1.254.412-7.838 23.863z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M35.018 17.216a.783.783 0 1 0 0-1.565.783.783 0 0 0 0 1.565M29.493 35.075a.247.247 0 0 0 .175.315 4.125 4.125 0 0 0 2.51-7.844.247.247 0 0 0-.325.156l-.47 1.473a.284.284 0 0 0 .155.343 2.066 2.066 0 0 1-1.25 3.903.284.284 0 0 0-.324.188zM29.241 28.84a.26.26 0 0 0-.346-.11l-1.915 1.106a.51.51 0 0 0-.21.665l.916 2.013c.067.127.22.175.346.112a.25.25 0 0 0 .128-.153l1.1-3.438a.28.28 0 0 0-.019-.195"
        }
      )
    ]
  }
);
var TabletIllustration_default = TabletIllustration;

export {
  TabletIllustration_default
};
